import React, { useEffect } from "react";
import { Grid } from "@material-ui/core";
import { useQuery, useQueryClient } from "react-query";
import { useFirebase } from "../Firebase";
import { useError } from "../ErrorProvider";
import Table from "../StyledComponents/MaterialTable";
import { PageHeader, TableSkeleton } from "../UI";
import CurrencyFormat from "react-currency-format";

const Participants = () => {
  const firebase = useFirebase();
  const { showError } = useError();
  const queryClient = useQueryClient();

  // Reset new user count when leaving this page
  useEffect(() => {
    return () => {
      firebase.resetNewUserCount().then(() => {
        queryClient.invalidateQueries("CompanyStatistics");
      });
    };
  }, [firebase, queryClient]);

  const { data, isLoading } = useQuery(
    "CompanyUsers",
    firebase.getCompanyUsers,
    {
      select: (data) => {
        let ret = data?.data;
        return ret.map((item) => ({
          ...item,
          accountStatus: item.accountStatus === "Active",
        }));
      },
      onError: (err) => showError(err),
    }
  );

  const updateUser = (oldData, newData) => {
    return firebase
      .setUser(newData.id, {
        email: newData.email,
        firstName: newData.firstName,
        lastName: newData.lastName,
        weeklySavingsAmount: newData.weeklySavingsAmount,
        drawingStatus: newData.accountStatus ? "eligible" : "ineligible",
      })
      .then((d) => {
        queryClient.invalidateQueries("CompanyUsers");
      });
  };

  const cols = [
    {
      title: "Status",
      field: "accountStatus",
      type: "boolean",
    },
    {
      title: "First Name",
      field: "firstName",
      defaultSort: "asc",
    },
    {
      title: "Last Name",
      field: "lastName",
    },
    {
      title: "Email",
      field: "email",
    },
    {
      title: "Amount Per Week",
      field: "weeklySavingsAmount",
      type: "numeric",
      render: (rowData) => (
        <CurrencyFormat
          value={
            rowData?.weeklySavingsAmount ? rowData?.weeklySavingsAmount : 0
          }
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
          decimalScale={2}
          fixedDecimalScale={true}
        />
      ),
    },
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PageHeader title="Participants" />
      </Grid>
      <Grid item xs={12}>
        {isLoading ? (
          <TableSkeleton rows={8} />
        ) : (
          <Table
            editable={{
              isDeleteHidden: () => true,
              isAddHidden: () => true,
              onRowUpdate: (newData, oldData) => {
                return updateUser(oldData, newData);
              },
            }}
            columns={cols}
            data={data}
            localization={{
              body: {
                emptyDataSourceMessage:
                  "No participants yet — employees appear here once they sign up.",
              },
            }}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default Participants;
